import {TSelectOption} from '@edna/components/Select/types';
import {TCurrency} from '@edna/utils';

import {EOperatorName, TSubject} from 'src/constants';
import {ESmsPricingType} from 'src/containers/TariffsCatalog';

export const NONE_SUBSCRIPTION = 'NONE';

export type TSubscription = {
  operator: EOperatorName;
  country: string;
  subscription: ESmsPricingType | typeof NONE_SUBSCRIPTION | null;
};

export type TSmsChannel = {
  id: number;
  name: string;
  tenantId?: number;
  createdAt: string;
  clientComment?: string | null;
  subject?: string | null;
  website?: string | null;
  exampleMessage?: string | null;
  subjectRef?: TSubject | null;
  updatedAt: string;
  status: EStatus;
  subscriptions: TSubscription[];
  availableTariffId?: number | null;
};

export enum EStatus {
  DRAFT = 'DRAFT',
  IN_PROGRESS = 'IN_PROGRESS',
  REJECTED = 'REJECTED',
  CREATE_SUBJECT = 'CREATE_SUBJECT',
  DONE = 'DONE',
  CREATE_SUBJECT_ERROR = 'CREATE_SUBJECT_ERROR',
}

export type TCountrySubscription = {
  country: string;
  options: TSubscription[];
};

export type TFormData = {
  id?: TSmsChannel['id'];
  name: TSmsChannel['name'];
  subject: TSmsChannel['subject'];
  website?: TSmsChannel['website'];
  operators: TSubscription[];
  countries: TCountrySubscription[];
  exampleMessage?: TSmsChannel['exampleMessage'];
  clientComment: TSmsChannel['clientComment'];
  availableTariffId?: TSmsChannel['availableTariffId'];
};

export type TOperatorOptions = Record<EOperatorName, TSelectOption[]>;

export type TSmsOperator = {
  operator: EOperatorName | string;
  country: string;
  subscriptions: ESmsPricingType[];
  currency?: TCurrency;
};

export type TSmsApprovedOperator = {
  operator: EOperatorName | string;
  subscription: ESmsPricingType;
};

export type TSmsApprovedDestination = {
  operatorCode: EOperatorName | string;
  country: string;
};

export const SMS_COUNTRY = 'RUS';
export const OPERATOR_NAMES = Object.values(EOperatorName);

export const DEFAULT_SMS_FORM_DATA: TFormData = {
  name: '',
  subject: '',
  website: '',
  operators: OPERATOR_NAMES.map((operator) => ({
    operator,
    country: SMS_COUNTRY,
    subscription: null,
  })),
  countries: [],
  exampleMessage: '',
  clientComment: '',
  availableTariffId: null,
};
